import React from "react";
import { Navigate } from "react-router-dom";
import { useUserContext } from "../context/UserContext";

const PrivateRoute = ({ children, redirectLink = "/" }) => {
  const { user } = useUserContext();
  return user ? children : <Navigate to={redirectLink} />;
};

export default PrivateRoute;
